import {
    GET_ACCOUNT,
    GET_SUPERVISOR_ACCOUNT,
    SUBMIT_DATA,
    GET_VALIDATE,
    GET_JEFE_DIRECTO,
    LSS_LOADING,
    LSS_ERROR,
  } from "../actions/LSSActions";
  
  const initialState = {
    user: {},
    accounts: [],
    supervisor_accounts: [],
    jefes: [],
    hasAnswered: false,
    loading: false,
    error: false,
    success: false,
    errorMessage: ""
  };
  
  const LSSReducer = function(state = initialState, action) {
    switch (action.type) {
      case LSS_LOADING: {
        return {
          ...state,
          loading: true
        };
      }
      case GET_ACCOUNT: {
        return {
          ...state,
          accounts: [...action.data],
          loading: false
        };
      }
      case GET_JEFE_DIRECTO: {
        return {
          ...state,
          jefes: [...action.data],
          loading: false
        };
      }
      case GET_SUPERVISOR_ACCOUNT: {
        return {
          ...state,
          supervisor_accounts: [...action.data],
          loading: false
        };
      }
      case SUBMIT_DATA: {
        return {
          ...state,
          loading: false,
          success: true
        };
      }
      case LSS_ERROR: {
        return {
          ...state,
          error: true,
          loading: false,
          errorMessage: action.data
        }
      }
      case GET_VALIDATE: {
        return {
          ...state,
          hasAnswered: action.data,
          loading: false,
          error: false,
          errorMessage: ""
        };
      }
      default: {
        return state;
      }
    }
  };
  
  export default LSSReducer;
  